export default __webpack_public_path__ + "static/screenshot-mybiz-4-88df3e32be8f999a8aa800ca668f985c.jpg";